module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Newschain_image_2.189537ba.png";